import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Typography } from "@mui/material";
import VendorConfig from "components/Admin/VendorConfig";
import DialogPrice from "components/Admin/DialogPrice";
import DialogDistance from "components/Admin/DialogDistance";
import DialogChange from "components/Admin/DialogExpiry";
import { ConfigTableApi } from "stores/VendorConfigStore/ConfigTableApi";

class VendorConfigContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      openprice: false,
      opendistance: false,
      Distance: "",
      cancelation: "",
      gracetime: "",
      advance: "",
      cancellation_time: "",
      grace_time: "",
      advance_charges: "",
      vendor_id: "",
      errorMassage: "",
      errorMassage2: "",
    };
  }

  componentDidMount() {
    let configId;
    if (this.props?.location?.vendorconfigId) {
      localStorage.setItem(
        "configId",
        JSON.stringify(this.props?.location?.vendorconfigId)
      );
      configId = this.props?.location?.vendorconfigId;
    } else {
      configId = localStorage.getItem("configId");
      if (configId) configId = JSON.parse(configId);
    }
    if (configId) {
      this.props.getConfigTableAction({ id: configId });
    }
  }

  updateExpiryDate = async () => {
    let configId = localStorage.getItem("configId");
    if (configId) configId = JSON.parse(configId);

    let value = this.state.cancellation_time;
    let id = this.state.vendor_id;

    if (value >= 1 && value <= 24) {
      await ConfigTableApi.UpdateConfigCancel({
        cancellation_time: value,
        vendor_id: id,
      });

      this.setState({ errorMassage: "" });

      await this.props.getConfigTableAction({ id: configId });
      this.handleClose();
    } else {
      this.setState({
        errorMassage: "please enter a valid number between 1 and 24",
      });
    }
  };

  updateGraceTime = async () => {
    let configId = localStorage.getItem("configId");
    if (configId) configId = JSON.parse(configId);

    let value = this.state.grace_time;
    let id = this.state.vendor_id;
    if (value) {
      await ConfigTableApi.UpdateConfigCancel({
        grace_time: value,
        vendor_id: id,
      });

      this.props.getConfigTableAction({ id: configId });
      this.closeprice();
    }
  };

  updateAdvanceCharge = async () => {
    let configId = localStorage.getItem("configId");
    if (configId) configId = JSON.parse(configId);

    let value = this.state.advance_charges;
    let id = this.state.vendor_id;

    if (value >= 1 && value <= 100) {
      await ConfigTableApi.UpdateConfigCancel({
        advance_charges: value,
        vendor_id: id,
      });
      this.setState({ errorMassage2: "" });
      this.props.getConfigTableAction({ id: configId });
      this.handleDistanceClose();
    } else {
      this.setState({
        errorMassage2: "please enter a valid number between 1 and 100",
      });
    }
  };

  onChangeAddExpiry = async (name, value) => {
    if (name == "cancle") {
      this.setState({ cancellation_time: value });
    }
    if (name == "time") {
      this.setState({ grace_time: value });
    }
    if (name == "advance") {
      this.setState({ advance_charges: value });
    }
  };

  handlePriceClickOpen = (gracetime, vendor_id) => {
    this.setState({
      openprice: true,
      gracetime: gracetime,
      vendor_id: vendor_id,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleClickOpen = (cancelation, vendor_id) => {
    this.setState({
      open: true,
      cancelation: cancelation,
      vendor_id: vendor_id,
    });
    this.setState({ errorMassage: "" });
  };

  closeprice = () => {
    this.setState({ openprice: false });
  };
  handleDistanceClickOpen = (advance, vendor_id) => {
    this.setState({
      opendistance: true,
      advance: advance,
      vendor_id: vendor_id,
    });
    this.setState({ errorMassage2: "" });
  };

  handleDistanceClose = async () => {
    this.setState({ opendistance: false });
  };

  render() {
    const data = this.props?.ConfigTableList?.result;
    const config = this.props?.location?.vendorconfigId?.name;

    return (
      <Grid container>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            style={{ color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Typography sx={{ color: "#A2A7AE", fontSize: "14px" }}>
              Vendor
            </Typography>
            <Typography sx={{ color: "#0DA861", fontSize: "14px" }}>
              Configuration
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <VendorConfig
              config={config}
              data={data}
              handlePriceClickOpen={(val1, val2) => {
                this.handlePriceClickOpen(val1, val2);
              }}
              handleDistanceClickOpen={(val1, val2) => {
                this.handleDistanceClickOpen(val1, val2);
              }}
              handleClickOpen={(val1, val2) => {
                this.handleClickOpen(val1, val2);
              }}
            />
          </Paper>
        </Grid>
        <DialogChange
          Cancelationperiod={this.state.cancelation}
          onChangeAddExpiry={this.onChangeAddExpiry}
          updateExpiryDate={this.updateExpiryDate}
          handleClose={this.handleClose}
          errorMassage={this.state.errorMassage}
          open={this.state.open}
        />
        <DialogPrice
          handlePriceClose={this.handlePriceClose}
          closeprice={this.closeprice}
          onChangeAddExpiry={this.onChangeAddExpiry}
          openprice={this.state.openprice}
          time={this.state.gracetime}
          updateGraceTime={this.updateGraceTime}
        />
        <DialogDistance
          onChangeAddExpiry={this.onChangeAddExpiry}
          updateDistance={this.updateDistance}
          handleDistanceClose={this.handleDistanceClose}
          open={this.state.opendistance}
          advance={this.state.advance}
          updateAdvanceCharge={this.updateAdvanceCharge}
          errorMassage2={this.state.errorMassage2}
        />
      </Grid>
    );
  }
}

export default VendorConfigContainer;
